/* eslint-disable eqeqeq */
import React from "react";
import { useNavigate } from "react-router-dom";

const ItemBody18 = ({ notification }) => {
  const navigate = useNavigate();

  const handleViewDetails = () => {
    navigate("/request-batteries", {
      state: {
        receiverHubId: notification?.metaData?.hubId || notification?.metaData?.hub_id,
        receiverHubName: notification?.metaData?.hubName || notification?.metaData?.hub_name,
        rentalId: notification?.metaData?.rentalId || notification?.metaData?.rental_id,
        driverId: notification?.metaData?.driverId || notification?.metaData?.driver_id,
        driverName: notification?.metaData?.driverName || notification?.metaData?.driver_name,
        notificationId: notification?.id,
      },
    });
  };

  return (
    <div>
      <p className="font-poppins text-xs font-light">
        <span className="text-primary font-medium">
          {notification?.metaData?.driverName || notification?.metaData?.driver_name}
        </span>{" "}
        <span className="capitalize">
          ({notification?.metaData?.hubName || notification?.metaData?.hub_name})
        </span>{" "}
        is requesting batteries to complete their rental trip. Do you want to
        accept?
      </p>

      {/* if action is performed, do not show the button */}
      {notification?.metaData?.action == 1 ? null : (
        <div className="mt-1 w-full flex items-center gap-x-2">
          <button
            type="button"
            className="bg-primary hover:bg-primary-50 py-2 px-4 rounded-md w-full"
            onClick={handleViewDetails}
          >
            <p className="font-poppins text-xs font-medium text-background-white text-center">
              View Details
            </p>
          </button>
        </div>
      )}
    </div>
  );
};

export default ItemBody18;
